import "./ourtemplate.css";
import React, { Fragment } from "react";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import TemplateGallery from "./template";
import TabSlider from "./tabslider";
function OurTemplate() {
    return (
        <Fragment>
            <TemplateGallery/>
        </Fragment>
    );
}

export default OurTemplate;